var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 py-5 text-center"},[_c('b-icon',{attrs:{"icon":"arrow-clockwise","animation":"spin","variant":"info","font-scale":"6"}}),_c('div',{staticClass:"w-100 py-4"}),_c('h3',{staticClass:"text-info"},[_vm._v("Loading........")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }